var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('p',{staticClass:"display-1"},[_vm._v("Vielen Dank für ihre Bestellung!")]),_c('order-detail',{attrs:{"print-button":"","order":_vm.order}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }